<template>
  <a-form :form="form" @submit.prevent="onSubmit" layout="vertical">
    <a-form-item v-bind="errorsBind('non_field_errors')" />
    <a-row :gutter="16">
      <a-col :span="12">
        <a-form-item label="Nazwa" v-bind="errorsBind('name')" required>
          <a-input v-model="form.name" />
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item label="Link" v-bind="errorsBind('url')" required>
          <a-input v-model="form.url" />
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import FieldHelper from '@/components/common/forms/FieldsHelper'

export default {
  extends: FieldHelper
}
</script>
